/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkflowTeam } from './workflowTeam';


export interface WorkflowTeamResultResponse { 
    /**
     * the total number of results
     */
    count: number;
    result: Array<WorkflowTeam>;
}

